<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Market Manager/ Rider
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 22 || roleid == 23">
        <b-tab-item label="ຟອມເພີ່ມ/ ແກ້ໄຂ Rider" disabled>
          <div class="columns section-title">
            ຂໍ້ມູນສ່ວນຕົວ
          </div>
          <div class="columns" v-if="adddataform">
            <div class="column">
              <div class="columns">
                <div class="column">
                  ຊື່ເຕັມ <span class="asterisk">*</span>
                  <b-field>
                    <b-input v-model.trim="farmerFullName"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  ເບີໂທ <span class="asterisk">*</span>
                  <b-field>
                    <b-input v-model.trim="farmerPhoneno"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  ປະເທດ <span class="asterisk">*</span>
                  <b-field label="">
                    <Multiselect
                      placeholder="ເລືອກ"
                      v-model.trim="farmerSelectedCountry"
                      label="NAME"
                      track-by="ID"
                      :options="countryList"
                      @input="onFarmerCountrySelected"
                    >
                    </Multiselect>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
          <div class="columns" v-if="adddataform">
            <div class="column">
              <div class="columns">
                <div class="column">
                  ແຂວງ <span class="asterisk">*</span>
                  <b-field label="">
                    <Multiselect
                      placeholder="ເລືອກ"
                      v-model.trim="farmerSelectedProvince"
                      label="NAME"
                      track-by="ID"
                      :options="farmerProvinceList"
                    >
                    </Multiselect>
                  </b-field>
                </div>
                <div class="column">
                  ເມືອງ <span class="asterisk">*</span>
                  <b-field label="">
                    <b-input v-model.trim="farmerDistrict"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  ບ້ານ <span class="asterisk">*</span>
                  <b-field label="">
                    <b-input v-model.trim="farmerVillage"> </b-input>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
          <div class="columns" v-if="adddataform">
            <div class="column">
              <div class="columns">
                <div class="column">
                  ລະຫັດໄປສະນີ <span class="asterisk">*</span>
                  <b-field label="">
                    <b-input v-model.trim="farmerPostCode"> </b-input>
                  </b-field>
                </div>
                <div class="column"></div>
                <div class="column"></div>
              </div>
            </div>
          </div>
          <hr />
          <div class="columns section-title">
            ຂໍ້ມູນຟາມ
          </div>
          <div class="columns" v-if="adddataform">
            <div class="column">
              <div class="columns">
                <div class="column">
                  ຊື່ຟາມ <span class="asterisk">*</span>
                  <b-field label="">
                    <b-input v-model.trim="farmname"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  ຂະໜາດຟາມ(ເຮັກຕາ) <span class="asterisk">*</span>
                  <b-field label="">
                    <b-input v-model.trim="farmSize"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  ໂຊນກະສິກຳ <span class="asterisk">*</span>
                  <b-field label="">
                    <b-input v-model.trim="agriZone"> </b-input>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
          <div class="columns" v-if="adddataform">
            <div class="column">
              <div class="columns">
                <div class="column">
                  ປະເທດ <span class="asterisk">*</span>
                  <b-field label="">
                    <Multiselect
                      placeholder="ເລືອກ"
                      v-model.trim="farmSelectedCountry"
                      label="NAME"
                      track-by="ID"
                      :options="countryList"
                      @input="onFarmCountrySelected"
                    >
                    </Multiselect>
                  </b-field>
                </div>
                <div class="column">
                  ແຂວງ <span class="asterisk">*</span>
                  <b-field label="">
                    <Multiselect
                      placeholder="ເລືອກ"
                      v-model.trim="farmSelectedProvince"
                      label="NAME"
                      track-by="ID"
                      :options="farmProvinceList"
                    >
                    </Multiselect>
                  </b-field>
                </div>
                <div class="column">
                  ເມືອງ <span class="asterisk">*</span>
                  <b-field label="">
                    <b-input v-model.trim="farmDistrict"> </b-input>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
          <div class="columns" v-if="adddataform">
            <div class="column">
              <div class="columns">
                <div class="column">
                  ບ້ານ <span class="asterisk">*</span>
                  <b-field label="">
                    <b-input v-model.trim="farmVillage"> </b-input>
                  </b-field>
                </div>
                <div class="column"></div>
                <div class="column"></div>
              </div>
            </div>
          </div>
          <hr />
          <div class="columns section-title">
            ຂໍ້ມູນຕິດຕໍ່/ ຜູ້ຮັບຜິດຊອບ
          </div>
          <div class="columns" v-if="adddataform">
            <div class="column">
              <div class="columns">
                <div class="column">
                  ຊື່ເຕັມ <span class="asterisk">*</span>
                  <b-field label="">
                    <b-input v-model.trim="contactFullName"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  ເບີໂທ 1 <span class="asterisk">*</span>
                  <b-field label="">
                    <b-input v-model.trim="contactPhoneno1"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  ເບີໂທ 2
                  <b-field label="">
                    <b-input v-model.trim="contactPhoneno2"> </b-input>
                  </b-field>
                </div>
              </div>

              <b-field label="" style="float: right">
                <b-field v-if="saveAction">
                  <button class="button is-info" @click="saveFarmer">
                    ບັນທຶກ
                  </button>
                </b-field>
                <b-field v-if="updateAction">
                  <div class="columns">
                    <div class="column">
                      <b-field>
                        <button class="button is-primary">
                          ແກ້ໄຂ
                        </button>
                      </b-field>
                    </div>
                    <div class="column">
                      <b-field>
                        <button
                          class="button is-info"
                          @click="openSaveFarmerForm"
                        >
                          ຟອມເພີ່ມສາຂາ
                        </button>
                      </b-field>
                    </div>
                  </div>
                </b-field>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="Rider ທີ່ລໍຖ້າອະນຸມັດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="Rider ທີ່ລໍຖ້າອະນຸມັດ">
                <b-button
                  class="btn-group-margin"
                  type="is-primary"
                  size="is-small"
                  @click="getRiderUsers()"
                  >ດືງຂໍ້ມູນ
                </b-button>

                <b-button
                  class="btn-group-margin"
                  type="is-danger"
                  size="is-small"
                  @click="apporveAllFarmer()"
                  >ອະນຸມັດທັງໝົດ
                </b-button>
              </b-field>
              <b-field>
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="2%">#</th>
                      <th class="has-text-left " width="10%">
                        ຊື່ເຕັມ
                      </th>
                      <th class="has-text-left " width="10%">
                        ເບີໂທ
                      </th>
                      <th class="has-text-left " width="15%">
                        ຕະຫຼາດ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in waitactiveriderusers"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.FULLNAME }}
                      </td>
                      <td>
                        {{ data.PHONENO }}
                      </td>

                      <td>
                        {{ data.MARKETNAME }}
                      </td>

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="updateFarmerForm(data)"
                              >ແກ້ໄຂ
                            </b-button>
                          </b-field>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-danger"
                              size="is-small"
                              @click="changeRiderStatus(data.USERNAME, 1)"
                              >ອະນຸມັດ
                            </b-button>
                          </b-field>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="Rider ທີ່ເປີດນຳໃຊ້">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="Rider ທີ່ເປີດໃຊ້ງານ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="2%">#</th>
                      <th class="has-text-left " width="10%">
                        ຊື່ເຕັມ
                      </th>
                      <th class="has-text-left " width="10%">
                        ເບີໂທ
                      </th>
                      <th class="has-text-left " width="15%">
                        ຕະຫຼາດ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in activeriderusers"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.FULLNAME }}
                      </td>
                      <td>
                        {{ data.PHONENO }}
                      </td>

                      <td>
                        {{ data.MARKETNAME }}
                      </td>

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              >ແກ້ໄຂ
                            </b-button>
                          </b-field>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-warning"
                              size="is-small"
                              @click="resetPassword(data.USERID)"
                              >ລີເຊັດລະຫັດ
                            </b-button>
                          </b-field>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-danger"
                              size="is-small"
                              @click="changeRiderStatus(data.USERNAME, 0)"
                              >ປິດນຳໃຊ້
                            </b-button>
                          </b-field>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="Rider ທີ່ຖືກປິດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="Rider ທີ່ຖືກປິດ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="2%">#</th>
                      <th class="has-text-left " width="10%">
                        ຊື່ເຕັມ
                      </th>
                      <th class="has-text-left " width="10%">
                        ເບີໂທ
                      </th>
                      <th class="has-text-left " width="15%">
                        ຕະຫຼາດ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in inactiveriderusers"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.FULLNAME }}
                      </td>
                      <td>
                        {{ data.PHONENO }}
                      </td>

                      <td>
                        {{ data.MARKETNAME }}
                      </td>

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-danger"
                              size="is-small"
                              @click="changeRiderStatus(data.USERNAME, 1)"
                              >ເປິດນຳໃຊ້
                            </b-button>
                          </b-field>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,
      riderid: null,
      FullName: null,
      Phoneno: null,
      oldPhoneno: null,
      farmerPostCode: null,
      farmerSelectedCountry: null,
      countryList: [],
      farmerSelectedProvince: null,
      farmerProvinceList: [],
      farmerDistrict: null,
      farmerVillage: null,

      marketid: null,

      farmID: null,
      farmname: null,
      farmSelectedCountry: null,
      farmSelectedProvince: null,
      farmProvinceList: [],
      farmDistrict: null,
      farmVillage: null,
      agriZone: null,
      farmSize: null,

      contactFullName: null,
      contactPhoneno1: null,
      contactPhoneno2: null,
      oldcontactPhoneno1: null,
      oldcontactPhoneno2: null,

      waitactiveriderusers: [],
      activeriderusers: [],
      inactiveriderusers: [],
      branchid: null,
      oldbranchname: null,
      branchname: null,
      countryid: null,
      provinceid: null,
      oldprovinceid: null,

      activeTab: 1,
      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,
    };
  },
  methods: {
    getCountry() {
      RestAPI.getCountry()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.countryList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    onFarmCountrySelected() {
      RestAPI.getProvincebyCountry(this.farmSelectedCountry.ID)
        .then((res) => {
          // console.log("country selected...")
          this.farmProvinceList = res.data;
          this.selectedProvince = null;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    onFarmerCountrySelected() {
      RestAPI.getProvincebyCountry(this.farmerSelectedCountry.ID)
        .then((res) => {
          // console.log("country selected...")
          this.farmerProvinceList = res.data;
          this.selectedProvince = null;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    saveFarmer() {
      if (
        this.farmerFullName === null ||
        this.farmerPhoneno === null ||
        this.farmerSelectedCountry === null ||
        this.farmerSelectedProvince === null ||
        this.farmerDistrict === null ||
        this.farmerVillage === null ||
        this.farmerPostCode === null ||
        this.farmname === null ||
        this.agriZone === null ||
        this.farmSize === null ||
        this.farmSelectedCountry === null ||
        this.farmSelectedProvince === null ||
        this.farmDistrict === null ||
        this.farmVillage === null ||
        this.contactFullName === null ||
        this.contactPhoneno1 === null
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else {
        var params = {
          farmerFullName: this.farmerFullName,
          farmerPassword: this.sha2(this.farmerPhoneno),
          farmerPhoneno: this.farmerPhoneno,
          farmerSelectedCountry: this.farmerSelectedCountry.ID,
          farmerSelectedProvince: this.farmerSelectedProvince.ID,
          farmerDistrict: this.farmerDistrict,
          farmerVillage: this.farmerVillage,
          farmerPostCode: this.farmerPostCode,
          farmname: this.farmname,
          agriZone: this.agriZone,
          farmSize: this.farmSize,
          farmSelectedCountry: this.farmSelectedCountry.ID,
          farmSelectedProvince: this.farmSelectedProvince.ID,
          farmDistrict: this.farmDistrict,
          farmVillage: this.farmVillage,
          contactFullName: this.contactFullName,
          contactPhoneno1: this.contactPhoneno1,
          contactPhoneno2: this.contactPhoneno2,
          username: this.username,
        };
        RestAPI.saveFarmer(params)
          .then((res) => {
            if (res.data == "duplicate farmerPhoneno") {
              this.$swal("ຂໍ້ມູນສ່ວນຕົວ/ ເບີໂທຊ້ຳ ", "-", "error");
              return false;
            }

            this.$swal("ບັນທືກ Farmer ສຳເລັດ!", "", "success");

            this.farmerFullName = null;
            this.farmerPhoneno = null;
            this.farmerSelectedCountry = null;
            this.farmerSelectedProvince = null;
            this.farmerDistrict = null;
            this.farmerVillage = null;
            this.farmerPostCode = null;
            this.farmname = null;
            this.agriZone = null;
            this.farmSize = null;
            this.farmSelectedCountry = null;
            this.farmSelectedProvince = null;
            this.farmDistrict = null;
            this.farmVillage = null;
            this.contactFullName = null;
            this.contactPhoneno1 = null;
            this.contactPhoneno2 = null;
            this.getRiderUsers();
            this.activeTab = 1;
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    getRiderUsers() {
      // var userProvinceID = this.roleid == 3 ? this.userProvinceID : 0;
      RestAPI.getRiderUsers(this.marketid)
        .then((res) => {
          console.log("lsit:" + JSON.stringify(res.data));
          this.waitactiveriderusers = res.data.waitactiveriderusers;
          this.activeriderusers = res.data.activeriderusers;
          this.inactiveriderusers = res.data.inactiveriderusers;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    updateFarmerForm(data) {
      // console.log(" data: " +JSON.stringify(data))
      //  console.log(" data.FARMERPOSTCODE: " +  data.FARMERPOSTCODE)
      this.activeTab = 0;
      this.saveAction = false;
      this.updateAction = true;

      this.farmerID = data.USERID;
      this.farmerFullName = data.FARMERFULLNAME;
      this.farmerPhoneno = data.FARMERPHONENO;
      this.oldfarmerPhoneno = data.FARMERPHONENO;
      this.farmerSelectedCountry = {
        ID: data.FARMERCOUNTRYID,
        NAME: data.FARMERCOUNTRY,
      };
      this.farmerSelectedProvince = {
        ID: data.FARMERPROVINCEID,
        NAME: data.FARMERPROVINCE,
      };
      this.farmerDistrict = data.FARMERDISTRICT;
      this.farmerVillage = data.FARMERVILLAGE;
      this.farmerPostCode = data.FARMERPOSTCODE;
      this.farmID = data.FARMID;
      this.farmname = data.FARMNAME;
      this.agriZone = data.ZONEID;
      this.farmSize = data.FARMSIZE;
      this.farmSelectedCountry = {
        ID: data.FARMCOUNTRYID,
        NAME: data.FARMCOUNTRY,
      };
      this.farmSelectedProvince = {
        ID: data.FARMPROVINCEID,
        NAME: data.FARMPROVINCE,
      };
      this.farmDistrict = data.FARMDISTRICT;
      this.farmVillage = data.FARMVILLAGE;
      this.contactFullName = data.CONTACTFULLNAME;
      this.contactPhoneno1 = data.CONTACTPHONENO1;
      this.contactPhoneno2 = data.CONTACTPHONENO2;
      this.oldcontactPhoneno1 = data.CONTACTPHONENO1;
      this.oldcontactPhoneno2 = data.CONTACTPHONENO2;
    },
    openSaveFarmerForm() {
      this.getRiderUsers();
      this.activeTab = 0;
      this.saveAction = true;
      this.updateAction = false;
      this.farmerFullName = null;
      this.farmerPhoneno = null;
      this.farmerSelectedCountry = null;
      this.farmerSelectedProvince = null;
      this.farmerDistrict = null;
      this.farmerVillage = null;
      this.farmerPostCode = null;
      this.farmname = null;
      this.agriZone = null;
      this.farmSize = null;
      this.farmSelectedCountry = null;
      this.farmSelectedProvince = null;
      this.farmDistrict = null;
      this.farmVillage = null;
      this.contactFullName = null;
      this.contactPhoneno1 = null;
      this.contactPhoneno2 = null;
    },
    updateFarmer() {
      if (
        this.farmerFullName === null ||
        this.farmerPhoneno === null ||
        this.farmerSelectedCountry === null ||
        this.farmerSelectedProvince === null ||
        this.farmerDistrict === null ||
        this.farmerVillage === null ||
        this.farmerPostCode === null ||
        this.farmname === null ||
        this.agriZone === null ||
        this.farmSize === null ||
        this.farmSelectedCountry === null ||
        this.farmSelectedProvince === null ||
        this.farmDistrict === null ||
        this.farmVillage === null ||
        this.contactFullName === null ||
        this.contactPhoneno1 === null
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else {
        var params = {
          farmerid: this.farmerID,
          farmerFullName: this.farmerFullName,
          farmerPhoneno: this.farmerPhoneno,
          oldfarmerPhoneno: this.oldfarmerPhoneno,
          farmerSelectedCountry: this.farmerSelectedCountry.ID,
          farmerSelectedProvince: this.farmerSelectedProvince.ID,
          farmerDistrict: this.farmerDistrict,
          farmerVillage: this.farmerVillage,
          farmerPostCode: this.farmerPostCode,
          farmID: this.farmID,
          farmname: this.farmname,
          agriZone: this.agriZone,
          farmSize: this.farmSize,
          farmSelectedCountry: this.farmSelectedCountry.ID,
          farmSelectedProvince: this.farmSelectedProvince.ID,
          farmDistrict: this.farmDistrict,
          farmVillage: this.farmVillage,
          contactFullName: this.contactFullName,
          contactPhoneno1: this.contactPhoneno1,
          contactPhoneno2: this.contactPhoneno2,
          oldcontactPhoneno1: this.oldcontactPhoneno1,
          oldcontactPhoneno2: this.oldcontactPhoneno2,
          username: this.username,
        };
        RestAPI.updateFarmer(params)
          .then((res) => {
            console.log("data: " + JSON.stringify(res.data));
            if (res.data == "duplicate farmerPhoneno") {
              this.$swal("ຂໍ້ມູນສ່ວນຕົວ/ ເບີໂທຊ້ຳ ", "-", "error");
              return false;
            } else if (res.data == "duplicate contactPhoneno1") {
              this.$swal("ຜູ້ຮັບຜິດຊອບ/ ເບີໂທຊ້ຳ ", "-", "error");
              return false;
            } else if (res.data == "duplicate contactPhoneno2") {
              this.$swal("ຜູ້ຮັບຜິດຊອບ/ ເບີໂທຊ້ຳ ", "-", "error");
              return false;
            }

            this.$swal("ແກ້ໄຂ Farmer ສຳເລັດ!", "", "success");

            this.farmerFullName = null;
            this.farmerPhoneno = null;
            this.farmerSelectedCountry = null;
            this.farmerSelectedProvince = null;
            this.farmerDistrict = null;
            this.farmerVillage = null;
            this.farmerPostCode = null;
            this.farmname = null;
            this.agriZone = null;
            this.farmSize = null;
            this.farmSelectedCountry = null;
            this.farmSelectedProvince = null;
            this.farmDistrict = null;
            this.farmVillage = null;
            this.contactFullName = null;
            this.contactPhoneno1 = null;
            this.contactPhoneno2 = null;
            this.getRiderUsers();
            this.activeTab = 1;
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    changeRiderStatus(farmerid, status) {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            userid: farmerid,
            status: status,
            username: this.username,
          };
          // console.log("par: " + JSON.stringify(params))
          RestAPI.changeRiderStatus(params)
            .then(() => {
              this.$swal("ດຳເນີນການສຳເລັດ!", "", "success");
              this.getRiderUsers();
            })
            .catch((error) => {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            });
        }
      });
    },

    apporveAllFarmer() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            username: this.username,
          };
          // console.log("par: " + JSON.stringify(params))
          RestAPI.apporveAllFarmer(params)
            .then(() => {
              this.$swal("ດຳເນີນການສຳເລັດ!", "", "success");
              this.getRiderUsers();
            })
            .catch((error) => {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            });
        }
      });
    },

    resetPassword(userid) {
      this.$swal({
        title: "ຕ້ອງານລີເຊັດລະຫັດຜ່ານ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            userid: userid,
            username: this.username,
          };
          RestAPI.resetPassword(params)
            .then(() => {
              this.$swal("ດຳເນີນການສຳເລັດ!", "", "success");
            })
            .catch((error) => {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            });
        }
      });
    },

    print() {
      window.print();
    },
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.marketid = this.user.MARKETID ? this.user.MARKETID : 0;
    console.log("this.user: " + JSON.stringify(this.user));
    this.getRiderUsers();
    this.getCountry();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.section-title {
  margin-top: 10px;
  font-size: 20;
  font-weight: bold;
  text-decoration: underline;
}
.asterisk {
  color: red;
}
</style>
